module.exports = __webpack_public_path__ + "img/3_f.4b3ab1ae.jpg";